import navigationService from './navigation-service/navigationService';
import notificationService from './notification-service/notificationService';
import taskTriggersService from './task-trigger-service/taskTriggersService';
import timezoneService from './timezone-service/timezoneService';

export default function (ngModule) {
  navigationService(ngModule);
  notificationService(ngModule);
  taskTriggersService(ngModule);
  timezoneService(ngModule);
}

